import { useTranslation } from "react-i18next";

import { Form } from "react-bootstrap";

function RCSInvoiceForm({ rcsInvoice, setRCSInvoice }) {
  const { t } = useTranslation();
  return (
    <div className="invoice-page__modal_form_invoice-container">
      <Form.Group>
        <Form.Label>Information sur l'ecole': </Form.Label>
        <Form.Control
          label="text"
          as="textarea"
          rows={8}
          columns={5}
          value={rcsInvoice.information_on_school}
          onChange={(e) =>
            setRCSInvoice({
              ...rcsInvoice,
              information_on_school: e.target.value,
            })
          }
        />
      </Form.Group>
    </div>
  );
}

export default RCSInvoiceForm;
